import React, { Component } from 'react'

import TicketSelectorList from './TicketSelectorList'
import SeatMapSelector from './seatmap/SeatMapSelector'
import { ErrorMessage } from '../../utils/ErrorMessages'
import HidingElement from '../../utils/HidingElement'
import PopupFrame from '../../../layout/parts/PopupFrame'
import { Rub, RedLine } from '../../utils/Symbols'
import Pixel, { PIXEL_ACTIONS } from '../../utils/Pixel'


export class TicketSelectorBlock extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: {}
        }
    }

    static getDerivedStateFromProps(newProps, prevState){
        return {
            errors: {...prevState.errors, ...newProps.errors}
        };
    }

    render () {
        return (
            <>
                <div className="tickets-popup-head mobile-only">
                    {this.props.performance.event.name}
                </div>
                <div className="mobile-only">
                    {this.props.performance.name}
                </div>
                <RedLine className="mobile-only" />

                <TicketSelectorChosenByType 
                    selectorType={this.props.selectorType}
                    performance={this.props.performance}
                    tickets={this.props.tickets} 
                    chosenTickets={this.props.chosenTickets}
                    onChange={this.handleChosenTicketsChange} />


                <div className="tickets-selector-row row">
                    <div className="tickets-button-block tickets-selector-main-text tickets-selector-footerline">

                        <div className="mobile-only tickets-selected-info">
                            <div className="tickets-selected-count">
                                Выбрано билетов:&nbsp;
                                <strong>{this.getChosenTicketsCount()}</strong>
                            </div>
                            <div className="tickets-selected-amount">
                                {this.getChosenTicketsCost()} <Rub />
                            </div>
                        </div>

                        <nobr className="desktop-only">
                            Выбрано билетов: <strong>{this.getChosenTicketsCount()}</strong>
                            &nbsp;
                            Итого:
                            &nbsp;
                            <span className="tickets-selector-big-text">
                                {this.getChosenTicketsCost()} <Rub />
                            </span>
                        </nobr>

                        <input className="tickets-button-primary"
                            type="submit"
                            onClick={this.handleSubmit}
                            value="Купить билет" />
                        <ErrorMessage for='tickets' errors={this.state.errors} />

                    </div>
                </div>

            </>
        );
    }

    handleChosenTicketsChange = (newChosenTickets) => {
        this.props.onUpdate({chosenTickets: newChosenTickets})
    }

    getChosenTicketsCost = () => {
        return this.props.chosenTickets.getCost()
    }

    getChosenTicketsCount = () => {
        return this.props.chosenTickets.getCount()
    }

    handleSubmit = () => {
        const errors = this.checkChosenTickets()
        this.setState({errors: errors})
        if (Object.keys(errors).length) return 
        else this.props.next()
    }

    checkChosenTickets = () => {
        var errors = {}
        if (this.props.chosenTickets.getCount() === 0) {
            errors['tickets'] = 'Выберите хотя бы один билет'
        }
        return errors
    }
}

export class TicketSelectorPopup extends HidingElement {
    renderIfEnabled () {
        return (
            <PopupFrame 
                title="Оформление заказа"
                onClose={this.props.onClose}>

                <TicketSelectorBlock 
                    selectorType={this.props.selectorType}
                    tickets={this.props.tickets}
                    performance={this.props.performance}
                    chosenTickets={this.props.chosenTickets}
                    next={this.props.next}
                    back={this.props.back}
                    onUpdate={this.props.onUpdate} />

                <Pixel 
                    eventId={this.props.performance.event.uuid} 
                    performanceId={this.props.performance.uuid} 
                    action={PIXEL_ACTIONS.WIDGET_OPEN_SELECTOR} />

            </PopupFrame>
        )
    }
}

class TicketSelectorChosenByType extends Component {
    render () {
        if (this.props.selectorType === 'seatmap') {
            return <SeatMapSelector
                    smEventId={this.props.performance.seatmap_event_id}
                    {...this.props} />
        }
        else {
            return <TicketSelectorList {...this.props} />
        }
    }
}
